define('helper-media-parseCaptions',[],function () {
    'use strict';

    function parse_timestamp(s) {
        var match = s.match(/^(?:([0-9]+):)?([0-5][0-9]):([0-5][0-9](?:[.,][0-9]{0,3})?)/);
        if (match == null) {
            throw 'Invalid timestamp format: ' + s;
        }
        var hours = parseInt(match[1] || "0", 10);
        var minutes = parseInt(match[2], 10);
        var seconds = parseFloat(match[3].replace(',', '.'));
        return seconds + 60 * minutes + 60 * 60 * hours;
    }

    function vtt_parser(vtt) {
        var lines = vtt.trim().replace('\r\n', '\n').split(/[\r\n]/).map(function (line) {
            return line.trim();
        });

        var cues = [],
            start = null,
            end = null,
            cue = null,
            payload = null;
        for (var i = 0; i < lines.length; i++) {
            if (lines[i].indexOf('-->') >= 0) {
                var splitted = lines[i].split(/[ \t]+-->[ \t]+/);
                if (splitted.length !== 2) {
                    throw 'Error when splitting "-->": ' + lines[i];
                }
                start = parse_timestamp(splitted[0]);
                end = parse_timestamp(splitted[1]);
            } else {
                if (lines[i] !== '') {
                    payload = lines[i];
                } else {
                    payload = null;
                }
            }
            if (start && end && payload) {
                if (window.VTTCue) {
                    cue = new VTTCue(start, end, payload);
                } else {
                    cue = new TextTrackCue(start, end, payload);
                }
                cues.push(cue);
            }
        }

        return cues;
    }

    return function (captionContent) {
        return vtt_parser(captionContent);
    }
});

